// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2M-vV","select":"Header_select__3e9vI","clinic":"Header_clinic__Glvd0"};